import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';
import BadgeQuestion from 'entity/BadgeQuestion';
import QuestionVisibility from 'enums/QuestionVisibility';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverviewComponent extends Loggable implements OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);
  @Input() public overview: BadgeQuestion[] = [];
  @Input() public visualIndicator?: string;

  public constructor() {
    super();
  }

  public getVisibilityTexts(visibility?: QuestionVisibility) {
    switch (visibility) {
      case QuestionVisibility.ALL:
        return 'Everyone';
      case QuestionVisibility.ACCOUNT_USERS:
        return 'Account only';
      case QuestionVisibility.HOSTS:
        return 'Hosts only';
      case QuestionVisibility.INTERNAL:
        return 'Internal only';
      default:
        return 'Everyone';
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
